import SecureLS from "secure-ls";

const ls = new SecureLS();

export default ls;
